import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useContractCard } from "../../state/contractCardState";
// Components
import { GenericListHeader } from "../../components/GenericHeader";
import { ContractCardForm } from "./ContractCardForm";
// MUI Imports
import Typography from "@mui/material/Typography";

export const ExistingContract = ({ id }) => {
  const [contract, setContract] = useState({});
  const { isPending, isError, error, data, isSuccess } = useContractCard(id);

  // Success Function
  const successFunc = () => {
    if (data.data.data.data.list.contract !== undefined) {
      setContract(data.data.data.data.list.contract[0]);
    }
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      {Object.keys(contract).length !== 0 ? (
        <>
          <GenericListHeader heading={`Contract - ${contract.contractCode}`} />
          <ContractCardForm contract={contract} />
        </>
      ) : (
        !isPending && <Typography>Contract not found</Typography>
      )}
    </>
  );
};
